import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57c7142d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap-top" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "top-list assistant" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "论文助手（参考文献格式生成）"),
  /*#__PURE__*/_createElementVNode("span", null, " 参考文献是论文的重要构成部分，也是学术研究过程之中对于所涉及到的所有文献资料的总结与概括，一般状况下需要笔者将论文之中的学术资料、论文研究文献、注释文献等等诸多资料进行集中展示与整合，进而集中地展现在论文形态之中。")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "explain" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "参考文献标准格式说明"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" [1] 余联庆, 枚元元, 李琳, 等. 闭链弓形五连杆越障能力分析与运动规划[J]. 机械工程学报, 2017,53(7): 69-75. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 按顺序分别为：[序号] 作者姓名. 篇名[参考文献的类型标识]. 期刊名称，期刊出版地：出版社，出版年份.卷号(期号)：起止页码 "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("其中参考文献的类型标识包括：[M]--专著 [C]--会议论文集 [N]--报纸文章 [J]--期刊文章 [D]--学位论文 [R]--报告 ")
  ])
], -1))
const _hoisted_6 = { class: "main" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1))

import { ref, reactive, onMounted } from "vue";
import type { FormInstance, FormRules } from "element-plus";
import { ElMessage, ElMessageBox } from "element-plus";
import useClipboard from "vue-clipboard3";


export default /*#__PURE__*/_defineComponent({
  __name: 'ThesisAssistant',
  setup(__props) {

const { toClipboard } = useClipboard();
const showClick = ref(false); //操作显示与否
const rowId = ref(); //操作id
const ruleFormRef = ref<FormInstance>();
const reference = ref(); //参考文献标准格式
const arr = ref([]);
const selectType = ref(0); //文献种类选择
const document = ref([
  {
    paper:
      "余联庆, 枚元元, 李琳,等. 闭链弓形五连杆越障能力分析与运动规划[J]. 机械工程学报, 2017, 53(7):69-75.",
    id: 1,
  },
]); //参考文献
const paperForm = reactive({
  title: "",
  type: "[J]",
  author: "",
  source: "",
  place: "",
  press: "",
  year: "",
  reel: "",
  issue: "",
  page1: "",
  page2: "",
  newPaper: "",
  date: "",
  edition: "",
});
const options = [
  {
    value: "[J]",
    label: "期刊文章",
  },
  {
    value: "[M]",
    label: "专著",
  },
  {
    value: "[C]",
    label: "会议论文集",
  },
  {
    value: "[D]",
    label: "学位论文",
  },
  {
    value: "[R]",
    label: "报告",
  },
  {
    value: "[N]",
    label: "报纸文章",
  },
];

const rules = reactive<FormRules>({
  title: [{ required: true, message: "请输入论文题目", trigger: "blur" }],
  type: [
    {
      required: true,
      message: "请选择文献种类",
      trigger: "change",
    },
  ],
  author: [
    {
      required: true,
      message: "请输入作者",
      trigger: "blur",
    },
  ],
  source: [
    {
      required: true,
      message: "请输入来源期刊",
      trigger: "blur",
    },
  ],
  place: [
    {
      required: true,
      message: "请输入出版地",
      trigger: "blur",
    },
  ],
  press: [
    {
      required: true,
      message: "请输入出版社",
      trigger: "blur",
    },
  ],
  year: [
    {
      required: true,
      message: "请输入出版年份",
      trigger: "blur",
    },
  ],
  reel: [
    {
      required: true,
      message: "请输入卷号",
      trigger: "blur",
    },
  ],
  issue: [
    {
      required: true,
      message: "请输入期号",
      trigger: "blur",
    },
  ],
  page1: [
    {
      required: true,
      message: "请输入起始页码",
      trigger: "blur",
    },
  ],
  page2: [
    {
      required: true,
      message: "请输入结束页码",
      trigger: "blur",
    },
  ],
  newPaper: [
    {
      required: true,
      message: "请输入报纸名",
      trigger: "blur",
    },
  ],
  date: [
    {
      required: true,
      message: "请输入出版日期",
      trigger: "blur",
    },
  ],
  edition: [
    {
      required: true,
      message: "请输入版次",
      trigger: "blur",
    },
  ],
});

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      if (paperForm.type == "[J]") {
        reference.value =
          paperForm.author.replace("，", ",") +
          "." +
          paperForm.title +
          paperForm.type +
          "." +
          paperForm.source +
          "," +
          paperForm.place +
          ":" +
          paperForm.press +
          "," +
          paperForm.year +
          "." +
          paperForm.reel +
          "(" +
          paperForm.issue +
          ")" +
          ":" +
          paperForm.page1 +
          "-" +
          paperForm.page2 +
          ".";
      } else if (paperForm.type == "[N]") {
        reference.value =
          paperForm.author.replace("，", ",") +
          "." +
          paperForm.title +
          paperForm.type +
          "." +
          paperForm.newPaper +
          "," +
          paperForm.date +
          "(" +
          paperForm.edition +
          ")" +
          ".";
      } else {
        reference.value =
          paperForm.author.replace("，", ",") +
          "." +
          paperForm.title +
          paperForm.type +
          "." +
          paperForm.place +
          ":" +
          paperForm.press +
          "," +
          paperForm.year +
          ":" +
          paperForm.page1 +
          "-" +
          paperForm.page2 +
          ".";
      }
      document.value.push({
        paper: reference.value,
        id: document.value.length + 1,
      });
      sessionStorage.setItem("data", JSON.stringify(document.value));
      formEl.resetFields();
      getPage();
    }
  });
};

// 一键清空
const handClear = () => {
  document.value = [];
  sessionStorage.removeItem("data");
};

// 一键复制
const handCopy = async (content) => {
  if (content.length > 0) {
    arr.value = [];
    content.forEach((item) => {
      arr.value.push(`[${item.id}]` + item.paper);
    });
    await toClipboard(Object.values(arr.value).join("\n"));
    ElMessage({
      message: "复制成功",
      type: "success",
    });
  }
};

// 鼠标移入
const enter = (row) => {
  showClick.value = true;
  rowId.value = row.id;
};

// 鼠标移出
const leave = () => {
  showClick.value = false;
};

// 上移
const moveUp = (item, index) => {
  if (index > 0) {
    let upData = document.value[index - 1];
    document.value.splice(index - 1, 1);
    document.value.splice(index, 0, upData);
  } else {
    ElMessage({
      message: "已经是第一条，不可上移",
      type: "warning",
    });
  }
};

// 下移
const moveDown = (item, index) => {
  if (index + 1 == document.value.length) {
    ElMessage({
      message: "已经是最后一条，不可下移",
      type: "warning",
    });
  } else {
    let downData = document.value[index + 1];
    document.value.splice(index + 1, 1);
    document.value.splice(index, 0, downData);
  }
};

// 复制
const copy = (item) => {
  toClipboard(`[${item.id}]` + item.paper);
  ElMessage({
    message: "复制成功",
    type: "success",
  });
};

// 删除
const del = (item, index) => {
  ElMessageBox.confirm("确定要删除吗?", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      document.value.splice(index, 1);
      let tableData = JSON.parse(sessionStorage.getItem("data"));
      tableData.splice(index, 1);
      sessionStorage.setItem("data", JSON.stringify(tableData));
      ElMessage({
        type: "success",
        message: "删除成功",
      });
      getPage();
    })
    .catch((e) => {
      console.log(e);
    });
};

// 文献种类改变
const handleSelectChange = (val) => {
  if (val == "[J]") {
    selectType.value = 0;
  } else if (val == "[M]" || val == "[C]" || val == "[D]" || val == "[R]") {
    selectType.value = 1;
  } else {
    selectType.value = 2;
  }
};

const getPage = () => {
  document.value = JSON.parse(sessionStorage.getItem("data")) || document.value;
};

onMounted(() => {
  getPage();
});

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ArrowUpBold = _resolveComponent("ArrowUpBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_DocumentCopy = _resolveComponent("DocumentCopy")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_card, {
          class: "card",
          shadow: "never"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_el_card, { shadow: "never" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, {
              "body-style": { background: '#f8f9fb' },
              shadow: "never"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 9 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form, {
                        "hide-required-asterisk": true,
                        model: paperForm,
                        "label-width": "80px",
                        size: "large",
                        "label-position": "left",
                        rules: rules,
                        ref_key: "ruleFormRef",
                        ref: ruleFormRef
                      }, {
                        default: _withCtx(() => [
                          (selectType.value == 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_el_form_item, {
                                  label: "论文题目",
                                  prop: "title"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: paperForm.title,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((paperForm.title) = $event)),
                                      modelModifiers: { trim: true },
                                      placeholder: "请输入题目",
                                      clearable: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "文献种类",
                                  prop: "type"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: paperForm.type,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((paperForm.type) = $event)),
                                      placeholder: "请选择文献种类",
                                      onChange: handleSelectChange
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (item) => {
                                          return _createVNode(_component_el_option, {
                                            label: item.label,
                                            key: item.value,
                                            value: item.value
                                          }, null, 8, ["label", "value"])
                                        }), 64))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "作者",
                                  prop: "author"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: paperForm.author,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((paperForm.author) = $event)),
                                      modelModifiers: { trim: true },
                                      placeholder: "请输入作者，逗号隔开",
                                      clearable: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "来源期刊",
                                  prop: "source"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: paperForm.source,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((paperForm.source) = $event)),
                                      modelModifiers: { trim: true },
                                      clearable: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_row, { gutter: 20 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 12 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, {
                                          label: "出版地",
                                          prop: "place"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: paperForm.place,
                                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((paperForm.place) = $event)),
                                              modelModifiers: { trim: true },
                                              clearable: ""
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 12 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, {
                                          label: "出版社",
                                          prop: "press"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: paperForm.press,
                                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((paperForm.press) = $event)),
                                              modelModifiers: { trim: true },
                                              clearable: ""
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_row, { gutter: 20 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 12 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, {
                                          label: "出版年份",
                                          prop: "year"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: paperForm.year,
                                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((paperForm.year) = $event)),
                                              modelModifiers: { trim: true },
                                              clearable: ""
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, { span: 12 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, {
                                          label: "卷号",
                                          prop: "reel"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: paperForm.reel,
                                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((paperForm.reel) = $event)),
                                              modelModifiers: { trim: true },
                                              clearable: ""
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "期号",
                                  prop: "issue"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: paperForm.issue,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((paperForm.issue) = $event)),
                                      modelModifiers: { trim: true },
                                      clearable: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "起止页码",
                                  required: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_col, { span: 11 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, { prop: "page1" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_input, {
                                                  modelValue: paperForm.page1,
                                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((paperForm.page1) = $event)),
                                                  modelModifiers: { trim: true },
                                                  clearable: ""
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, {
                                          span: 2,
                                          class: "text-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_7
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, { span: 11 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, { prop: "page2" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_input, {
                                                  modelValue: paperForm.page2,
                                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((paperForm.page2) = $event)),
                                                  modelModifiers: { trim: true },
                                                  clearable: ""
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ], 64))
                            : _createCommentVNode("", true),
                          (selectType.value == 1)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_el_form_item, {
                                  label: "论文题目",
                                  prop: "title"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: paperForm.title,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((paperForm.title) = $event)),
                                      modelModifiers: { trim: true },
                                      placeholder: "请输入题目",
                                      clearable: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "文献种类",
                                  prop: "type"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: paperForm.type,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((paperForm.type) = $event)),
                                      placeholder: "请选择文献种类",
                                      onChange: handleSelectChange
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (item) => {
                                          return _createVNode(_component_el_option, {
                                            label: item.label,
                                            key: item.value,
                                            value: item.value
                                          }, null, 8, ["label", "value"])
                                        }), 64))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "作者",
                                  prop: "author"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: paperForm.author,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((paperForm.author) = $event)),
                                      modelModifiers: { trim: true },
                                      placeholder: "请输入作者，逗号隔开",
                                      clearable: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_col, { span: 11 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, {
                                          label: "出版地",
                                          prop: "place"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: paperForm.place,
                                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((paperForm.place) = $event)),
                                              modelModifiers: { trim: true },
                                              clearable: ""
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_col, {
                                      span: 11,
                                      offset: 2
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, {
                                          label: "出版社",
                                          prop: "press"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: paperForm.press,
                                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((paperForm.press) = $event)),
                                              modelModifiers: { trim: true },
                                              clearable: ""
                                            }, null, 8, ["modelValue"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "出版年份",
                                  prop: "year"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: paperForm.year,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((paperForm.year) = $event)),
                                      modelModifiers: { trim: true },
                                      clearable: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "起止页码",
                                  required: ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_col, { span: 11 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, { prop: "page1" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_input, {
                                                  modelValue: paperForm.page1,
                                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((paperForm.page1) = $event)),
                                                  modelModifiers: { trim: true },
                                                  clearable: ""
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, {
                                          span: 2,
                                          class: "text-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_8
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_col, { span: 11 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_form_item, { prop: "page2" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_input, {
                                                  modelValue: paperForm.page2,
                                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((paperForm.page2) = $event)),
                                                  modelModifiers: { trim: true },
                                                  clearable: ""
                                                }, null, 8, ["modelValue"])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ], 64))
                            : _createCommentVNode("", true),
                          (selectType.value == 2)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createVNode(_component_el_form_item, {
                                  label: "论文题目",
                                  prop: "title"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: paperForm.title,
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((paperForm.title) = $event)),
                                      modelModifiers: { trim: true },
                                      placeholder: "请输入题目",
                                      clearable: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "文献种类",
                                  prop: "type"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: paperForm.type,
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((paperForm.type) = $event)),
                                      placeholder: "请选择文献种类",
                                      onChange: handleSelectChange
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(options, (item) => {
                                          return _createVNode(_component_el_option, {
                                            label: item.label,
                                            key: item.value,
                                            value: item.value
                                          }, null, 8, ["label", "value"])
                                        }), 64))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "作者",
                                  prop: "author"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: paperForm.author,
                                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((paperForm.author) = $event)),
                                      modelModifiers: { trim: true },
                                      placeholder: "请输入作者，逗号隔开",
                                      clearable: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "报纸名",
                                  prop: "newPaper"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: paperForm.newPaper,
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((paperForm.newPaper) = $event)),
                                      modelModifiers: { trim: true },
                                      clearable: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "出版日期",
                                  prop: "date"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: paperForm.date,
                                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((paperForm.date) = $event)),
                                      modelModifiers: { trim: true },
                                      clearable: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "版次",
                                  prop: "edition"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: paperForm.edition,
                                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((paperForm.edition) = $event)),
                                      modelModifiers: { trim: true },
                                      clearable: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["model", "rules"]),
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            color: "#0054fe",
                            size: "large",
                            onClick: _cache[25] || (_cache[25] = ($event: any) => (submitForm(ruleFormRef.value)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("添加文献")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 14,
                    offset: 1
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table, {
                        data: document.value,
                        border: "",
                        "show-header": false,
                        style: {"width":"100%"},
                        "row-style": { height: '60px', color: '#9BA2AB' },
                        onCellMouseEnter: enter,
                        onCellMouseLeave: leave
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_table_column, {
                            "show-overflow-tooltip": true,
                            prop: "paper"
                          }, {
                            default: _withCtx((scope) => [
                              _createElementVNode("span", null, " [" + _toDisplayString(scope.$index + 1) + "]", 1),
                              _createElementVNode("span", null, _toDisplayString(scope.row.paper), 1),
                              (showClick.value && rowId.value == scope.row.id)
                                ? (_openBlock(), _createBlock(_component_el_row, {
                                    key: 0,
                                    class: "operate"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, {
                                        onClick: ($event: any) => (moveUp(scope.row, scope.$index))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ArrowUpBold)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_el_button, {
                                        onClick: ($event: any) => (moveDown(scope.row, scope.$index))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ArrowDownBold)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_el_button, {
                                        onClick: ($event: any) => (copy(scope.row))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_DocumentCopy)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_el_button, {
                                        onClick: ($event: any) => (del(scope.row, scope.$index))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Delete)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["data"]),
                      _createVNode(_component_el_row, { class: "button" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            color: "#0054fe",
                            size: "large",
                            onClick: _cache[26] || (_cache[26] = ($event: any) => (handCopy(document.value)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("一键复制")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_button, {
                            color: "#0054fe",
                            size: "large",
                            onClick: handClear
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("一键清空")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})